import React from 'react';
import { m } from '../../../utils';

import SingleShift from './SingleShift';

const ShiftsList = ({ selectedShifts = [], removeFromSelectedShifts }) => (
  <div>
    {selectedShifts
      .sort((a, b) => m(a.startTime) - m(b.startTime))
      .map(shift => (
        <SingleShift
          key={shift.startTime}
          removeFromSelectedShifts={removeFromSelectedShifts}
          shift={shift}
        />
      ))}
  </div>
);

export default ShiftsList;



// WEBPACK FOOTER //
// ./src/components/Book/SelectedShifts/ShiftsList.js